import { SUBCATEGORIES } from '../../common/categories';
import * as actions from './NhiActions';
import { commonActionsReducer } from '../../common/actions';
import { AD_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import { StaticCustomInsight } from '../../../../sharedComponents/scope/types';

const { NHI_ON_PREM } = SUBCATEGORIES;
const INSIGHT_ID = 'SERVICE_ACCOUNT';
const OWNERS_SYNC_CONFIG_ID = 'OWNERS_SYNC_CONFIG';

export const fieldsReducer = (state, action) => {
    const customInsights = state[NHI_ON_PREM.ID].fields.customInsight[action.payload.fieldId];
    switch (action.type) {
        case actions.Add_TO_CUSTOM_INSIGHT_ARRAY:
            return addCustomInsightNameConvention(state, customInsights, action);
        case actions.REMOVE_CUSTOM_INSIGHT_ARRAY_ITEM:
            return removeCustomInsightNameConvention(state, customInsights, action);
        case actions.EDIT_CUSTOM_INSIGHT_ARRAY_ITEM:
            return editCustomInsightNameConvention(state, customInsights, action);
        case actions.ADD_ENTITY:
            return addEntity(state, action);
        case actions.REMOVE_ENTITY:
            return removeEntity(state, customInsights, action);
        case actions.EDIT_OWNERS_SYNC_CONFIG:
            return editOwnersConfig(state, action);
        default:
            return commonActionsReducer(state, action, initFieldsState);
    }
};

const addEntity = (state, action) => {
    state[NHI_ON_PREM.ID].fields.customInsight[action.payload.fieldId] = action.payload.values;
    return state;
};

const removeEntity = (state, customInsights, action) => {
    state[NHI_ON_PREM.ID].fields.customInsight[action.payload.fieldId] = customInsights.filter(
        (item) => action.payload.value.guid !== item.guid
    );
    return state;
};
const addCustomInsightNameConvention = (state, customInsights, action) => {
    const exists = customInsights.some(
        (item) =>
            item.conditionString === action.payload.value.conditionString &&
            item.conditionType === action.payload.value.conditionType
    );
    if (!exists) {
        state[NHI_ON_PREM.ID].fields.customInsight[action.payload.fieldId] = [...customInsights, action.payload.value];
    }
    return state;
};
const removeCustomInsightNameConvention = (state, customInsights, action) => {
    state[NHI_ON_PREM.ID].fields.customInsight[action.payload.fieldId] = customInsights.filter(
        (item) =>
            item.conditionString !== action.payload.value.conditionString ||
            item.conditionType !== action.payload.value.conditionType
    );
    return state;
};
const editCustomInsightNameConvention = (state, customInsights, action) => {
    const exists = customInsights.some(
        (item) =>
            item.conditionString === action.payload.value.newConditionString &&
            item.conditionType === action.payload.value.newConditionType
    );
    if (exists) {
        return removeCustomInsightNameConvention(state, customInsights, {
            payload: {
                fieldId: action.payload.fieldId,
                value: {
                    conditionString: action.payload.value.oldConditionString,
                    conditionType: action.payload.value.oldConditionType
                }
            }
        });
    }
    state[NHI_ON_PREM.ID].fields.customInsight[action.payload.fieldId] = customInsights.map((item) =>
        item.conditionString === action.payload.value.oldConditionString &&
        item.conditionType === action.payload.value.oldConditionType
            ? {
                  conditionString: action.payload.value.newConditionString,
                  conditionType: action.payload.value.newConditionType
              }
            : item
    );
    return state;
};

const editOwnersConfig = (state, action) => {
    state[NHI_ON_PREM.ID].fields.ownersConfig.value = {
        ...state[NHI_ON_PREM.ID].fields.ownersConfig.value,
        ...action.payload
    };
    return { ...state };
};

export const initFieldsState = ({ settings }) => {
    const customInsights: StaticCustomInsight[] = settings.StaticCustomInsights.filter(
        (x: StaticCustomInsight) => x.name === INSIGHT_ID
    );

    const customInsight: StaticCustomInsight | null = customInsights.length > 0 ? customInsights[0] : null;

    return {
        [NHI_ON_PREM.ID]: {
            id: NHI_ON_PREM.ID,
            name: NHI_ON_PREM.NAME,
            fields: {
                customInsight: {
                    id: INSIGHT_ID,
                    name: INSIGHT_ID,
                    isStatic: true,
                    lastModified: customInsight?.lastModified || Date.now(),
                    excludedConditions: customInsight?.excludedConditions || [],
                    conditions: customInsight?.conditions || [],
                    excludedUsersAndGroups: customInsight?.excludedUsersAndGroups || [],
                    usersAndGroups: customInsight?.usersAndGroups || [],
                    validators: {},
                    entityType: AD_ENTITY_TYPES.USER
                },
                ownersConfig: {
                    id: OWNERS_SYNC_CONFIG_ID,
                    name: OWNERS_SYNC_CONFIG_ID,
                    value: settings.ServiceAccountsOwnersSyncConfig
                },
                validators: {}
            }
        }
    };
};

export const mapCustomInsightsToSettings = (saveAll, selectedTab, fields, settings) => {
    const otherCustomInsights = settings.StaticCustomInsights.filter((x) => x.name !== INSIGHT_ID);
    return {
        StaticCustomInsights: [...otherCustomInsights, fields[NHI_ON_PREM.ID].fields.customInsight],
        UserCustomInsights: settings.UserCustomInsights
    };
};

export const mapOwnersConfigToSettings = (saveAll, selectedTab, fields, settings) => {
    return {
        ServiceAccountsOwnersSyncConfig: fields[NHI_ON_PREM.ID].fields.ownersConfig.value
    };
};
